import Reflux from 'reflux'

let BankActions = Reflux.createActions([
  'setData',
  'setFlag',
  'setProcessed',
  'setUnprocessed'
])

export default BankActions


// WEBPACK FOOTER //
// ./src/actions/bankactions.js